module.exports = __webpack_public_path__ + "empty_cart.png?908bd0f19c8b56f26958f7965800852c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/empty_cart.png
// module id = 106
// module chunks = 0